import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService, AuthService, InterceptorConfig, RequestMetadata } from '@eceos/arch';
import { LoginResult, LoginValidator } from '@eceos/common-pages';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoginService implements LoginValidator {
  private metadata: RequestMetadata = { autoCatch: InterceptorConfig.NO_INTERCEPT };

  constructor(private api: ApiService, private authService: AuthService, private router: Router) {}

  validateLogin(username: string, password: string): Observable<LoginResult> {
    if (!username || !password) {
      return of(LoginResult.fail('Credenciais inválidas'));
    } else {
      const split = username.split('@');
      if (split.length !== 2) {
        return of(LoginResult.fail('Informe o usuário no padrão usuario@empresa'));
      } else {
        return this.getJwtToken(split[0], split[1], password);
      }
    }
  }

  private getJwtToken(user: string, enterprise: string, password: string): Observable<LoginResult> {
    return this.api.root
      .path(`login`)
      .getText({
        headers: new HttpHeaders().set(
          'Authorization',
          `Basic ${btoa(`${user}@${enterprise}:${password}`)}`
        ),
        metadata: this.metadata
      })
      .pipe(
        map(token => {
          if (token) {
            this.authService.publishLogin(token);
            this.router.navigate(['/']);
            return LoginResult.success('Login efetuado com sucesso');
          } else {
            return LoginResult.fail('Falha ao efetuar o login');
          }
        }),
        catchError(e => of(LoginResult.fail('Falha ao efetuar o login')))
      );
  }
}
